"use strict";

var _taggedTemplateLiteral = require("/root/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inputSelectReadOnly = exports.inputSelect = void 0;

var _stylitas = require("@creditas/stylitas");

var inputSelect = function inputSelect(_ref) {
  var as = _ref.as;
  return as === 'select' && (0, _stylitas.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    -moz-appearance: none;\n    -webkit-appearance: none;\n    appearance: none;\n  "])));
};

exports.inputSelect = inputSelect;

var inputSelectReadOnly = function inputSelectReadOnly(_ref2) {
  var readOnly = _ref2.readOnly;
  return readOnly && (0, _stylitas.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    pointer-events: none;\n  "])));
};

exports.inputSelectReadOnly = inputSelectReadOnly;